import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../misc/guards/authenticated.guard';
import { FarmAlertsPageComponent } from './farm-alerts.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: FarmAlertsPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class FarmAlertsPageRoutingModule {}
